import React from 'react';
import {
  ClientEmployeesQuery,
  useClientEmployeesQuery,
} from '../../graphql/datamodel.gen';
import { getClient } from '../../apollo';
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Dropdown, Empty, Menu, Table, Tag } from 'antd';
import CreateEmployeeDrawer from './CreateEmployee';
import UpdateEmployeeDrawer from './UpdateEmployee';

interface ClientEmployeesProps {}

const ClientEmployees: React.FC<ClientEmployeesProps> = (
  props: ClientEmployeesProps,
) => {
  const { loading: loadingEmployees, data: dataEmployees } =
    useClientEmployeesQuery({
      client: getClient(),
      fetchPolicy: 'cache-and-network',
    });

  const employees = dataEmployees?.clientEmployees || [];

  return (
    <ClientEmployeesView
      employees={employees}
      loadingTable={loadingEmployees}
    />
  );
};

type ClientEmployee = ClientEmployeesQuery['clientEmployees'][number];

interface ClientEmployeesViewState {
  createEmployeeVisible: boolean;
  manageEmployeeVisible: boolean;
  selectedEmployeeId?: string;
}
interface ClientEmployeesViewProps {
  loadingTable: boolean;
  employees: ClientEmployeesQuery['clientEmployees'];
}

class ClientEmployeesView extends React.Component<
  ClientEmployeesViewProps,
  ClientEmployeesViewState
> {
  state = {
    createEmployeeVisible: false,
    manageEmployeeVisible: false,
    selectedEmployeeId: undefined,
  };

  openCreateEmployee = () => {
    this.setState({
      createEmployeeVisible: true,
    });
  };

  hideCreateEmployee = () => {
    this.setState({
      createEmployeeVisible: false,
    });
  };

  openManageEmployee = () => {
    this.setState({
      manageEmployeeVisible: true,
    });
  };

  hideManageEmployee = () => {
    this.setState({
      manageEmployeeVisible: false,
      selectedEmployeeId: undefined,
    });
  };

  render() {
    const columns = [
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Nombre',
        dataIndex: 'name',
      },
      {
        title: 'Teléfono',
        dataIndex: 'phone',
      },
      {
        title: 'Acceso al Web Panel',
        key: 'access',
        render: (_: any, record?: ClientEmployee) => {
          if (record?.hasWebPanelAccount && record?.loginEnabled) {
            return <Tag color={'green'}>Sí</Tag>;
          }

          return <Tag color={'volcano'}>No</Tag>;
        },
      },
      {
        title: 'Acciones',
        key: 'actions',
        render: (_, record: ClientEmployee) => {
          const menus = (
            <Menu>
              <Menu.Item
                onClick={() => {
                  this.setState(
                    {
                      selectedEmployeeId: record.id,
                    },
                    () => {
                      this.openManageEmployee();
                    },
                  );
                }}
              >
                Gestionar empleado
              </Menu.Item>
            </Menu>
          );

          return (
            <Dropdown overlay={menus}>
              <Button size="small">
                Acciones <DownOutlined translate={undefined} />
              </Button>
            </Dropdown>
          );
        },
      },
    ];

    return (
      <div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'baseline',
            justifyContent: 'flex-start',
            paddingBottom: '2em',
          }}
        >
          <div style={{ marginLeft: 'auto' }}>
            <Button
              icon={<PlusOutlined translate={undefined} />}
              type={'primary'}
              onClick={this.openCreateEmployee}
            >
              Crear empleado
            </Button>
          </div>
        </div>
        <Table
          locale={{
            emptyText: (
              <Empty
                description={'No hay empleados en el sistema'}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            ),
          }}
          rowKey={(record) => record.id}
          loading={this.props.loadingTable}
          size={'middle'}
          pagination={{ pageSize: 25 }}
          columns={columns}
          // @ts-ignore
          dataSource={this.props.employees}
          // scroll={{ y: 'calc(50vh)' }}
        />
        <CreateEmployeeDrawer
          visible={this.state.createEmployeeVisible}
          onClose={this.hideCreateEmployee}
        />
        <UpdateEmployeeDrawer
          visible={this.state.manageEmployeeVisible}
          onClose={this.hideManageEmployee}
          employeeId={this.state.selectedEmployeeId}
        />
      </div>
    );
  }
}

export default ClientEmployees;
